<template>
  <div class="study-template" theme>
    <div id="study-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'study',
      parts: [
        {
          elem: '#study-content',
          htmlFile: 'study'
        }
      ]
    }
  }
}
</script>
